import { TPostInput } from '@cromwell/core';
import { Field, InputType, Int } from 'type-graphql';

import { CustomDateScalar } from '../objects/custom-date.scalar';
import { BasePageInput } from './base-page.input';

@InputType({ description: 'New Post data' })
export class UpdatePost extends BasePageInput implements TPostInput {
  @Field(() => String, { nullable: true })
  title: string;

  @Field((type) => Int)
  authorId: number;

  @Field(() => String, { nullable: true })
  mainImage?: string;

  @Field((type) => String, { nullable: true })
  readTime?: string | null;

  @Field((type) => [Int], { nullable: true })
  tagIds?: number[] | null;

  @Field(() => String, { nullable: true })
  content: string;

  @Field(() => String, { nullable: true })
  delta: string;

  @Field((type) => String, { nullable: true })
  excerpt?: string | null;

  @Field(() => Boolean, { nullable: true })
  published: boolean;

  @Field(() => Boolean, { nullable: true })
  featured?: boolean;

  @Field((type) => CustomDateScalar, { nullable: true })
  publishDate?: Date | null;
}
